import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { RunTaskParams } from '@eggplant/types'

interface Props {
  onSuccess: () => void
  params: RunTaskParams
  testConfigId: string
  children?: () => ReactElement
}

const RunTaskInstantRequest = ({
  children,
  onSuccess,
  params,
  testConfigId
}: Props) => {
  const url = `${TASK_SERVICE}/task_instances/${testConfigId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default RunTaskInstantRequest
